import React from 'react';
import {Link} from 'react-router-dom';
import {Button, Dropdown, Image, MenuItem, Nav, Navbar, NavItem} from 'react-bootstrap';

const styles = {
    brand: {
        paddingLeft: 31,
        color: '#FF841F',
        fontSize: 26,
        fontWeight: '800',
        fontFamily: "Montserrat",
    },
    navbar: {
        boxShadow: "0 2px 16px 0 rgba(177,177,177,0.5)",
        color: "white",
        fontFamily: 'Montserrat',
        position: 'fixed',
        width: '100%',
        zIndex: 120
    },
    brand_subscript: {
        color: "#333333",
        fontSize: 14,
        float: 'right'
    },
    profile_button: {
        backgroundColor: 'white',
        color: '#333333',
        fontSize: 14,
        backgroundImage: 'none',
        border: 'none',
        textShadown: 'none',
        boxShadow: 'none',
    },
    navbar_item: {
        marginTop: 6
    }
}


const Designmaker_Navbar = ({ user }) => {
    try {

        const inmagine_login = () => {
            window.localStorage.setItem('last_url', window.location.href);
            window.location.href = global.config.designs_ai_server_path + "user/sign-in?c="+global.config.dm_client_id+"&r=" + global.config.auth_redirect_path_dm;
        };

        const inmagine_logout = () => {
            window.localStorage.setItem('last_url', window.location.href);
            fetch(global.config.server_path+'user/logout', {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include'})
                .then(res => {
                    window.location.href = global.config.designs_ai_server_path + "user/sign-out?c="+global.config.dm_client_id+"&r=" + global.config.auth_redirect_path_dm;
                })
                .catch(err => {
                    console.error(err);
                    window.location.href = global.config.designs_ai_server_path + "user/sign-out?c="+global.config.dm_client_id+"&r=" + global.config.auth_redirect_path_dm;
                })
        };

        return (
            <Navbar id="header-dai" inverse collapseOnSelect style={styles.navbar}>
                <Navbar.Brand style={{paddingRight: 0}}>
                    <a href="/">
                        <div style={{width: 217, paddingRight: 15, display: 'inline-block'}}>
                            <img style={{width: '100%'}}
                                 src={global.config.website_url + "designmaker/start/icons/designs_ai_logo.png"}/>
                        </div>
                    </a>
                    <Link to="/designmaker/start">
                        <div style={{display: 'inline'}}>
                            <img
                                src={global.config.server_path + 'public/images/logo_designmaker.png'}/>
                        </div>
                    </Link>
                </Navbar.Brand>
                <Navbar.Toggle/>
                <Navbar.Collapse>
                    <Nav>
                        <NavItem>

                        </NavItem>
                    </Nav>

                    <Nav pullRight>
                        <NavItem style={styles.navbar_item}>
                            {user ? (
                                <Dropdown id="dropdown-custom-1" >
                                    <Dropdown.Toggle style={styles.profile_button} >
                                        <Image src="https://image.flaticon.com/icons/svg/206/206853.svg"
                                               className="circle" style={{
                                            position: 'absolute',
                                            left: '-40px',
                                            bottom: 0,
                                            height: 40
                                        }}/>
                                        {user.name} &nbsp;
                                        <span className="fa fa-caret-down"></span>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu id="trashy" className="super-colors">
                                        <MenuItem onClick={inmagine_logout}>Logout</MenuItem>
                                    </Dropdown.Menu>
                                </Dropdown>
                            ) : (
                                <Button onClick={inmagine_login} className="btn btn-login" id="login_button">
                                    Sign in    
                                </Button>
                            )}
                        </NavItem>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        );
    } catch(err) {
        return 'Navbar has malfunctioned'
    }
};

export default Designmaker_Navbar;